<template>
    <div>
        <div class="table-layout">
            <el-table ref="staffList" :data="staffList" border style="width: 100%" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column type="selection" :selectable="isDisable" width="55"></el-table-column>
                <el-table-column align="center" width="130" prop="no" label="员工编号"></el-table-column>
                <el-table-column align="left" width="130" prop="name" label="员工姓名"></el-table-column>
                <el-table-column align="center" width="130" prop="contactTel" label="联系电话"></el-table-column>
                <el-table-column align="center" width="130" prop="enrollDate" label="入职日期"></el-table-column>
                <el-table-column align="center" width="130" prop="contactEmail" label="电子邮箱"></el-table-column>
                <el-table-column align="center" prop="osFlag" label="是否外协">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.osFlag">是</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label class="">已选择的收信人</label>
                </div>
                <div class="form-value flex">
                    <ul class="enum-list mt5">
                        <li class="enum-item checked" v-for="staff in staffCheckList">
                            <span>{{staff.name}}</span>
                            <span class="delete" @click="remove(staff.id)">×</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-com-staff-list-for-msg',
        desc: '公司员工列表（站内信使用）',
        props: ['comId', 'transOrgFlag'],
        data: function () {
            return {
                staffList: [],
                staffCheckList: [],
            }
        },
        created: function () {
            this.getStaffList();
        },
        watch: {
            comId: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.getStaffList();
                    //
                    if(!this.transOrgFlag){
                        this.staffCheckList = [];
                    }
                }
            }
        },
        methods: {
            getStaffList: function () {
                let self = this;
                let postData = {};
                postData.comId = this.comId;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerStaffListForMsg(postData, function (result) {
			        theLoad.hide();
                    if(result.type == "info") {
                        //
                        self.staffList = result.data;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            handleSelectionChange(selection, row) {
                let self = this;
                let staffIdList = this.staffCheckList.pluck("id");
                for(let i = 0; i < selection.length; i++) {
                    let staff = selection[i];
                    if(staffIdList.indexOf(staff.id) < 0) {
                        self.staffCheckList.push(staff);
                    }
                }
                // 为了 取消掉 已选择状态...
                self.getStaffList();
            },
            isDisable: function (row) {
                //
                let staffIdList = this.staffCheckList.pluck("id");
                if(staffIdList.indexOf(row.id) < 0) {
                    return true;
                } else {
                    return false;
                }
            },
            remove: function (staffId) {
                let staffCheckList = this.staffCheckList;
                for(let i = 0; i < staffCheckList.length; i++) {
                    let staff = staffCheckList[i];
                    if(staff.id == staffId) {
                        staffCheckList.remove(staff);
                    }
                }
                //
                this.getStaffList();
            },
            getDlgResult: function () {
                let result = {};
                let staffIdList = this.staffCheckList.pluck("id");
                if(Utils.isNoB(staffIdList)) {
                    result.type = 'warn';
                    result.message = '请选择接收者！';
                } else {
                    result.type = 'info';
                    result.data = staffIdList;
                }
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/orgStruct/ComStaffListForMsg.vue